module.exports = __webpack_public_path__ + "static/media/story-15-1.30b66ae2.jpg";